{
  "id": "campaign-090",
  "name": "Ivy Knoll",
  "seed": "campaign:90",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "....L__L....",
    ".....__.....",
    "....,__.%%..",
    "...,,__.%...",
    "....,__.....",
    ".i.i.__,i.i.",
    ".....__,....",
    "....T__T....",
    ".i.i.__.i.i.",
    ".....__....,",
    ".,..L__L..,.",
    ",i,i.__.i.i,",
    ".,...__.....",
    "....#__..#..",
    ".L...__...L.",
    "...#........",
    "x..........S"
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 11,
      "y": 3
    },
    {
      "kind": "squirrel",
      "x": 7,
      "y": 15
    },
    {
      "kind": "squirrel",
      "x": 3,
      "y": 4
    },
    {
      "kind": "squirrel",
      "x": 8,
      "y": 12
    },
    {
      "kind": "rabbit",
      "x": 0,
      "y": 10
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 10,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 4
    }
  ],
  "generatorVersion": 3,
  "level": 90,
  "biome": "cemetery",
  "par": {
    "reel": 7438,
    "push": 5837,
    "selfPropelled": 5118,
    "tractor": 4405,
    "zeroTurn": 3686,
    "fairway": 2502
  },
  "routeTries": {
    "par": {
      "reel": 8,
      "push": 6,
      "selfPropelled": 14,
      "tractor": 24,
      "zeroTurn": 4,
      "fairway": 13
    }
  }
}
